import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { IngredientsServices } from "../../../services";

/**
 * Generated class for the IngredientPartialAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-partial-allergens',
    templateUrl: 'ingredient-partial-allergens.html',
})
export class IngredientPartialAllergensPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public ingredientServices: IngredientsServices) {
    }

    checkState(allergen_uid) {
        var index = this.ingredientServices.ingredient_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            return true
        } else {
            return false
        }

    }

    insert(allergen_uid) {
        this.ingredientServices.ingredient_allergens_tmp.push(allergen_uid);
    }

    delete(allergen_uid) {
        var index = this.ingredientServices.ingredient_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            this.ingredientServices.ingredient_allergens_tmp.splice(index, 1);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-allergens/ingredient-partial-allergens/ingredient-partial-allergens.ts